import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { selectNotification } from '../../store/slice'
import { Action } from './Action'
import ActiveIcon from './ActiveIcon'
import Message from './Message'

export const StatusNotificationItem = ({
  id,
  isLastIndex,
  screenType,
  timeType,
}) => {
  const [isActive, setIsActive] = useState(false)

  const { title, createdAt, isRead, isShow, ...other } = useSelector(
    selectNotification(screenType, timeType, id),
  )

  const onMouseEnter = () => {
    setIsActive(true)
  }

  const onMouseLeave = () => {
    setIsActive(false)
  }

  if (!isShow) return null

  return (
    <Element
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="dFlex alignItemsCenter cursorPointer"
      style={{
        columnGap: '4px',
        backgroundColor: isActive ? '#F3F3F3' : 'transparent',
      }}
    >
      <ActiveIcon isRead={isRead} />
      <Message
        isRead={isRead}
        title={title}
        createdAt={createdAt}
        id={id}
        screenType={screenType}
        timeType={timeType}
        {...other}
      />
      <Action
        id={id}
        isRead={isRead}
        isLastIndex={isLastIndex}
        screenType={screenType}
        timeType={timeType}
      />
    </Element>
  )
}

StatusNotificationItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    isRead: PropTypes.bool.isRequired,
  }),
}
